import axiosInstance from "../../apiAxios/axiosInstance";

// Category List
export const ProductList = async(payload) => {
const response=  await axiosInstance.post("/vendor/product-list",payload);
return response.data
};
export const ActiveProductList = async(payload) => {
const response=  await axiosInstance.post("/vendor/active-product-list",payload);
return response.data
};
export const CityList = async(payload) => {
const response=  await axiosInstance.post("/admin/city-list",payload);
return response.data
};
export const StateList = async(payload) => {
const response=  await axiosInstance.post("/admin/state-list",payload);
return response.data
};

export const AddProduct = async(payload) => {
  return axiosInstance.post("/vendor/product-store", payload);
};

export const ViewProductDetail = async(payload) => {
  return axiosInstance.post("/vendor/product-show", payload);
};

export const UpdateProduct = async(payload) => {
  return axiosInstance.post("/vendor/product-update", payload);
};

// Delete
// export const DeleteProduct = (payload) => {
//   return axiosInstance.post("/admin/product-delete", payload);
// };

export const DeleteProduct = async (payload) => {
  const response = await axiosInstance.post(
    "/vendor/product-delete",
    payload
  );
  return response.data;
};

export const ProductChangeStatus = (payload) => {
  return axiosInstance.post("/vendor/product-status-update", payload);
};